module.exports = __webpack_public_path__ + "media/images/app/collections/layered-necklaces-513c668c6bf9ee1b0b5a2df3dbd7e222.webp";